import { z } from 'zod';

export const otherCompanyIDsSchema = z.array(z.string());

export type otherCompanyIDs = z.infer<typeof otherCompanyIDsSchema>;
